export const Empty = () => (
  <>
    <h2 className="sectionHb-title">Empty</h2>
  </>
)
